export enum BasketMergeTypes {
  ABANDONED = 'ABANDONED',
  PERSONAL_SHOPPING_ADVICE = 'PERSONAL_SHOPPING_ADVICE',
}

export enum DynamicMessagesCalculateTypes {
  TOTAL = 'total',
  SUBTOTAL = 'subtotal',
}

export enum BasketCartItemError {
  ADD_FAILED = 'ADD_FAILED',
}

export enum BasketUpdateStatus {
  ERROR = 'ERROR',
  OUTOFSTOCK = 'OUTOFSTOCK',
  BUNDLE_OUTOFSTOCK = 'BUNDLE_OUTOFSTOCK',
  SUCCESS = 'SUCCESS',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  BULK_OUTOFSTOCK = 'BULK_OUTOFSTOCK',
}

export enum BasketButtonError {
  SKU = 'SKU',
  SKU_STICKY_BAR = 'SKU_STICKY_BAR',
  SKU_OPEN_SIZE_SELECT = 'SKU_OPEN_SIZE_SELECT',
  STOCK = 'STOCK',
  SIZE_COMBINATION_NOT_EXIST = 'SIZE_COMBINATION_NOT_EXIST',
}

export enum BasketResponseCode {
  HD_EXCLUDED = 'basket.hd.excluded',
  CC_EXCLUDED = 'basket.cc.excluded',
  SS_EXCLUDED = 'product.ss.excluded',
}

export enum BasketStatus {
  LOADING = 0,
  EMPTY = 1,
  READY = 2,
  ERROR = 3,
}

export enum CheckoutBlockedReason {
  HD_EXCLUDED = 'HD excluded',
  CC_EXCLUDED = 'C&C excluded',
  SSE_PRODUCT = 'SSE product',
  SPECIALTY_PRODUCT = 'Specialty product',
}
